class MiniCart extends HTMLElement {
  constructor() {
    super();

    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(html => {
        document.getElementById('mini-cart').innerHTML =
          this.getSectionInnerHTML(html, '.shopify-section');
          
          document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
      })
      .catch(e => {
        console.error(e);
      });
  }

  open() {
    this.drawer = document.querySelector('cart-drawer') || this.drawer;

    const detailsElement = this.drawer?.querySelector('details');
    if (!detailsElement || detailsElement.hasAttribute('open')) {
      return;
    }

    const summaryElement = detailsElement.querySelector(':scope > summary') || this.drawer?.querySelector('summary');
    summaryElement?.click();
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      document.getElementById(section.id).innerHTML =
        this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
}

customElements.define('mini-cart', MiniCart);

/* 4PIXELS: always resolve the current side-cart DOM before opening it. */
window.__fourPixelsOpenSideCart = window.__fourPixelsOpenSideCart || (() => {
  const drawer = document.querySelector('cart-drawer');
  const detailsElement = drawer?.querySelector('details');

  if (!detailsElement) return false;
  if (detailsElement.hasAttribute('open') || detailsElement.open === true) return true;

  const summaryElement = detailsElement.querySelector(':scope > summary') || drawer?.querySelector('summary');
  if (!summaryElement) return false;

  summaryElement.click();
  return true;
});

/* 4PIXELS: keep normal Add to Cart separate from the bundle builder. */
(() => {
  if (window.__fourPixelsNormalAtcGuardInstalled) return;
  window.__fourPixelsNormalAtcGuardInstalled = true;

  document.addEventListener('submit', async (event) => {
    const form = event.target instanceof HTMLFormElement ? event.target : null;
    if (!form || !form.action || !form.action.includes('/cart/add')) return;

    const section = form.closest('.shopify-section');
    if (!section || !section.querySelector('[data-fp-add-current], [data-fp-submit]')) return;

    const submitter = event.submitter instanceof Element ? event.submitter : null;

    if (
      submitter?.closest('.shopify-payment-button') ||
      submitter?.matches('.shopify-payment-button__button')
    ) {
      return;
    }

    if (
      submitter?.matches('[data-fp-add-current], [data-fp-submit]') ||
      submitter?.closest('[data-fp-add-current], [data-fp-submit]')
    ) {
      return;
    }

    const isAddToCart = !submitter || submitter.matches(
      "[name='add'], .add-to-cart-button, [ref='addToCartButton'], [data-testid='add-to-cart'], button[type='submit'], input[type='submit']"
    );

    if (!isAddToCart) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    if (form.dataset.fpCartSubmitting === 'true') return;
    form.dataset.fpCartSubmitting = 'true';

    const submitButton = submitter || form.querySelector(
      "[name='add'], .add-to-cart-button, [ref='addToCartButton'], [data-testid='add-to-cart'], button[type='submit'], input[type='submit']"
    );

    if (submitButton) {
      submitButton.classList.add('loading');
      if ('disabled' in submitButton) submitButton.disabled = true;
    }

    const miniCart = document.querySelector('mini-cart');
    const formData = new FormData(form);

    if (miniCart && typeof miniCart.getSectionsToRender === 'function') {
      const sections = miniCart
        .getSectionsToRender()
        .map((section) => section.section || section.id)
        .filter(Boolean);

      formData.set('sections', sections.join(','));
      formData.set('sections_url', window.location.pathname);
    }

    const config = typeof fetchConfig === 'function'
      ? fetchConfig('javascript')
      : { method: 'POST', headers: { Accept: 'application/json' } };

    config.method = 'POST';
    config.headers = config.headers || {};
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    config.body = formData;

    try {
      const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', config);
      const parsedState = await response.json();

      if (!response.ok || parsedState.status) {
        throw new Error(parsedState.description || parsedState.message || 'Unable to add this item to the cart.');
      }

      if (
        miniCart &&
        parsedState.sections &&
        typeof miniCart.renderContents === 'function'
      ) {
        miniCart.renderContents(parsedState);
      } else {
        window.__fourPixelsOpenSideCart?.();
      }

      document.dispatchEvent(new CustomEvent('cart:updated', {
        detail: { cart: parsedState }
      }));
    }
    catch (error) {
      console.error('[4PIXELS Add to Cart]', error);

      const errorWrapper = form.querySelector('.product-form__error-message-wrapper');
      const errorMessage = errorWrapper?.querySelector('.product-form__error-message');

      if (errorWrapper && errorMessage) {
        errorMessage.textContent = error.message;
        errorWrapper.removeAttribute('hidden');
      }
    }
    finally {
      delete form.dataset.fpCartSubmitting;

      if (submitButton) {
        submitButton.classList.remove('loading');
        if ('disabled' in submitButton) submitButton.disabled = false;
      }
    }
  }, true);
})();

/* 4PIXELS: open the same side cart after a completed bundle is added. */
(() => {
  if (window.__fourPixelsBundleDrawerOpenInstalled) return;
  window.__fourPixelsBundleDrawerOpenInstalled = true;

  const handleBundleCartUpdated = (event) => {
    if (event?.detail?.source !== 'fourpixels-persistent-bundle') return;

    const openCurrentSideCart = () => {
      window.__fourPixelsOpenSideCart?.();
    };

    requestAnimationFrame(() => requestAnimationFrame(openCurrentSideCart));
    window.setTimeout(openCurrentSideCart, 120);
    window.setTimeout(openCurrentSideCart, 350);
  };

  document.addEventListener('cart:updated', handleBundleCartUpdated);
  window.addEventListener('cart:updated', handleBundleCartUpdated);
})();
